import ExampleTitle from './ExampleTitle'

ExampleTitle.install = function install (Vue) {
  Vue.component(ExampleTitle.name, ExampleTitle)
}

export default ExampleTitle



// WEBPACK FOOTER //
// ./src/components/example-title/index.js